var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDissatisfied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8003 35.3672C13.7634 35.3303 13.6879 35.2337 13.6079 35.0205C13.5271 34.8049 13.4996 34.6341 13.4995 34.501V34.0732L15.2954 26.9736L15.689 25.417L4.99951 25.417C4.46395 25.4169 3.99823 25.2311 3.55029 24.7832C3.10238 24.3352 2.9165 23.8696 2.9165 23.334V20.001C2.9165 19.8952 2.92792 19.7644 2.95752 19.6064C2.98346 19.4681 3.02104 19.3479 3.06592 19.2432L3.06689 19.2402L8.06201 7.50293C8.20263 7.19619 8.44676 6.89942 8.85986 6.62402C9.25858 6.35821 9.63141 6.25104 9.99951 6.25098H25.4165L25.4165 26.1494L14.9995 36.5664L13.8003 35.3672ZM31.2495 25.417L31.2495 6.25098H35.4165L35.4165 25.417H31.2495Z",
    fill: "#EDADA5",
    stroke: "#DE323B",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissatisfied);
export default __webpack_public_path__ + "static/media/Dissatisfied.f2fcfd0a8bd3fd0104474bb90713e474.svg";
export { ForwardRef as ReactComponent };